import createAdapter from './createAdapter'

export const facebook = createAdapter(() => !!window.fbq, {
  page() {
    fbq('track', 'PageView')
  },
  track(eventName, parameters) {
    fbq('track', eventName, parameters)
  },
})
